import * as Sentry from '@sentry/react';
import { getEnv, isProduction } from './env';

export function initSentry(): void {
  const dsn = getEnv('VITE_SENTRY_DSN');

  if (!isProduction() || !dsn) {
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: 'production',

    beforeSend(event, hint) {
      const error = hint.originalException;

      if (error instanceof Error) {
        if (error.message.includes('fetch') || error.message.includes('Network')) {
          return null;
        }
        if (error.name === 'AbortError') {
          return null;
        }
      }

      if (event.request) {
        delete event.request.cookies;
        if (event.request.query_string && typeof event.request.query_string === 'string') {
          event.request.query_string = event.request.query_string
            .replace(/token=[^&]*/g, 'token=[FILTERED]')
            .replace(/key=[^&]*/g, 'key=[FILTERED]');
        }
      }

      return event;
    },

    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'chrome-extension://',
      'moz-extension://',
      '__REACT_DEVTOOLS_GLOBAL_HOOK__',
    ],
  });
}

export function captureException(error: Error | unknown, context?: Record<string, unknown>): void {
  if (isProduction()) {
    Sentry.captureException(error, { extra: context });
  } else {
    console.error('Error captured:', error, context);
  }
}

export function setUser(user: { id: string; email?: string; username?: string } | null): void {
  if (isProduction()) {
    Sentry.setUser(user);
  }
}

export { Sentry };
